import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useReligion() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/religion/")
    .then((res: SuccessFetch<{
      payload: {
        religion_id: number
        religion_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.religion_name, value: item.religion_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/religion/")
    .then((res: SuccessFetch<{
      payload: {
        religion_id: number
        religion_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.religion_name, value: item.religion_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}